import { categories } from '@/mocks/articles';
import { Link } from 'react-router-dom';

interface CategoryTabsProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryTabs({ activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-nowrap">
      <button
        onClick={() => onCategoryChange('all')}
        className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
          activeCategory === 'all'
            ? 'bg-primary-500 text-background-50'
            : 'bg-secondary-100 text-foreground-700 hover:bg-secondary-200'
        }`}
      >
        全部
      </button>
      {categories.map((cat) => (
        <button
          key={cat.slug}
          onClick={() => onCategoryChange(cat.slug)}
          className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
            activeCategory === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-100 text-foreground-700 hover:bg-secondary-200'
          }`}
        >
          {cat.name}
        </button>
      ))}
    </div>
  );
}